var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSortDate31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7h16v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h2v2h6V2h2v2h1a2 2 0 0 1 2 2v1H2V6a2 2 0 0 1 2-2h1V2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.998 9-2.644 2.237 1.292 1.527L13 11.618V18h2V9h-2.002Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5A.5.5 0 0 0 7 12v-.5a.5.5 0 0 0-1 0H4a2.5 2.5 0 0 1 5 0v.5c0 .571-.191 1.098-.514 1.518.323.428.514.96.514 1.538v.444a2.5 2.5 0 0 1-5 0h2a.5.5 0 0 0 1 0v-.444a.556.556 0 0 0-.556-.556H6v-2c.167 0 .334-.004.5 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24 15-4 5V5h2v10h2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSortDate31);
export default __webpack_public_path__ + "static/media/ic_action_sort_date_31.3a46cc47aedb66805515e13787174e37.svg";
export { ForwardRef as ReactComponent };